<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb />
      </div>
    </div>
    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
          <div class="col-12 d-flex col-xl-4 mb-1 mb-xl-0">
            <h4 class="font-weight-bold">贈品管理</h4>
            <div class="ml-4 py-2">
              <b-input-group>
                <b-form-checkbox
                  v-model="query.is_enabled"
                  value="1"
                  unchecked-value="0"
                  >只包含已啟用</b-form-checkbox
                >
              </b-input-group>
            </div>
          </div>
          <div
            class="
              col-12 col-xl-6
              d-flex
              flex-column flex-xl-row
              align-items-end align-items-xl-center
            "
          >
            <div class="flex-shrink-0">
              <b-button
                v-if="checkPermission([consts.REDEEM_LIST_VIEW])"
                class="mb-2 mb-xl-0 mr-2 ml-n3 ml-xl-0"
                variant="link"
                :to="{
                  name: 'RedeemLogList',
                }"
              >
                <i class="fa fa-folder-open"></i>贈品兌換紀錄
              </b-button>
              <b-button
                class="flex-shrink-0 mb-2 mb-xl-0 mr-3 py-2"
                variant="primary"
                :to="{ name: 'GiftCreate' }"
                ><i class="fa fa-plus" aria-hidden="true"></i>新增贈品
              </b-button>
            </div>
            <b-input-group class="ml-0 ml-xl-4">
              <b-form-input
                placeholder="名稱"
                v-model="query.keyword"
                v-on:keyup.enter="handlePageReset"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="handlePageReset"
                  ><i class="fa fa-search"></i
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <b-table
          responsive
          striped
          hover
          :items="gifts"
          :fields="fields"
          @sort-changed="handleSort"
        >
          <template #cell(image_url)="data">
            <b-img-lazy
              v-if="data.item.image_url"
              class="thumb-image"
              :src="data.item.image_url"
              alt="商品圖片"
              width="50"
              height="50"
            />
          </template>
          <template #cell(started_at_and_end_at)="data">
            <div class="mb-1">
              {{ formatDate(data.item.available_start_at) }}
            </div>
            <div>{{ formatDate(data.item.available_end_at) }}</div>
          </template>
          <template #cell(branch)="data">
            <div class="mb-1">
              {{ data.item.branch ? data.item.branch.name : "" }}
            </div>
            <div>
              {{ data.item.branch ? data.item.branch.branch_code : "" }}
            </div>
          </template>
          <template #cell(arrange)="data">
            <b-button
              class="ml-2"
              variant="inverse-info"
              v-if="checkPermission([consts.GIFT_LIST_MODIFY])"
              :to="{
                name: 'GiftUpdateImage',
                params: {
                  gift_id: data.item.id,
                },
              }"
              >設定圖片
            </b-button>
            <b-button
              class="ml-2"
              variant="inverse-warning"
              v-if="checkPermission([consts.GIFT_LIST_MODIFY])"
              :to="{
                name: 'GiftEdit',
                params: {
                  gift_id: data.item.id,
                },
              }"
              >編輯
            </b-button>
          </template>
        </b-table>
        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import giftApi from "../../../apis/gift";
import moment from "moment";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { CustomPagination, BreadCrumb },
  data() {
    return {
      consts,
      showLoading: false,
      selectedMerchantID: null,
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      fields: [
        {
          key: "name",
          label: "贈品名稱",
          sortable: true,
        },
        {
          key: "image_url",
          label: "贈品圖片",
        },
        {
          key: "event_id",
          label: "活動ID",
        },
        {
          key: "point_need",
          label: "所需點數",
          sortable: true,
        },
        {
          key: "quantity",
          label: "贈品剩餘數量",
          sortable: true,
        },
        {
          key: "original_quantity",
          label: "贈品初始數量",
          sortable: true,
        },
        {
          key: "type",
          label: "贈品類型",
        },
        {
          key: "is_enabled",
          label: "狀態",
          formatter: (value) => {
            return value ? "啟用" : "停用";
          },
        },
        {
          key: "arrange",
          label: "管理",
        },
      ],
      gifts: [],
      permissionChecker: new PermissionChecker(),
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        sort_by: "created_at",
        order_by: "desc",
        is_enabled: 1,
        keyword: null,
      },
    };
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchGifts();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  mounted() {
    this.fetchGifts();
    this.initialized = true;
  },
  computed: {
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}-${this.query.is_enabled}`;
    },
  },
  methods: {
    async fetchGifts() {
      this.showLoading = true;

      try {
        const { data } = await giftApi.getGifts({ ...this.query });

        this.gifts = data.data;
        this.totalRows = data.meta.total;
        this.perPage = data.meta.per_page;
      } catch (error) {
        console.error(error);
        alert("取得商品資料錯誤");
      }
      this.showLoading = false;
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm");
      }
    },
    checkPermission(permissions) {
      return this.permissionChecker.check(permissions);
    },
    handleSort(ctx) {
      this.query.sort_by = ctx.sortBy;
      this.query.order_by = ctx.sortDesc ? "desc" : "asc";
      this.handlePageReset();
    },
    handlePageChange(newPage) {
      this.query.page = newPage;
    },
    handlePerPageChange(newPerPage) {
      this.query.per_page = newPerPage;
      this.query.page = 1;
    },
    handleSearch() {
      this.handlePageReset();
    },
    handlePageReset() {
      const currentPage = parseInt(this.query.page, 10);

      if (currentPage === 1) {
        updateUrl(this.query, this.$store, this.$router);
      } else {
        this.query.page = 1;
      }
    },
  },
};
</script>

<style>
.modal-backdrop {
  opacity: 0.5;
}
</style>
